module.exports = new __parcel__URL__("symbols_dark.cd4eb434.png").toString();